import { useAuth } from '@/contexts'
import { ISlot } from '@namuho/types'
import { useQuery } from '@tanstack/react-query'
import { getUnixTime, parseISO } from 'date-fns'

export const useSlots = () => {
    const baseUrl = `${import.meta.env.VITE_API_URL}/api/slots`

    const { getAccessToken, session } = useAuth()
    const slotsQuery = useQuery({
        queryKey: ['slots'],
        queryFn: async (): Promise<ISlot[]> => {
            const response = await fetch(`${baseUrl}`, {
                method: 'GET',
                headers: {
                    'Content-Type': 'application/json',
                    Authorization: (await getAccessToken()) || '',
                },
            })

            if (!response.ok) {
                throw new Error(response.statusText)
            }

            return response.json()
        },
        enabled: !!session,
    })

    const slotsFromQuery = slotsQuery?.data || []
    const slotsFromTheFuture = slotsFromQuery?.filter((slot: ISlot) => slot.date > new Date().toISOString()) || []
    const sortedSlots = slotsFromTheFuture?.sort((a: ISlot, b: ISlot) => getUnixTime(parseISO(b.date)) - getUnixTime(parseISO(a.date))) || []

    return {
        isLoading: slotsQuery?.isLoading || false,
        slots: sortedSlots || [],
    }
}
